module.exports = __webpack_public_path__ + "static/media/ballot_black_24dp.cfe3db5a.svg";